export default {
  types: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/messageTemplateType/state.js